export abstract class BaseShortCardClass {
  noClick(e: any) {}
}
